import _ from 'lodash'
import ChooseCannedReportStep from '../choose-report/choose-canned-report-step'
import template from './choose-scorecard-report-step.hbs'
import OwnerUpdaterPath from '../owner-updater/owner-updater-path'
import MetricComparisonPath from '../metric-comparison/metric-comparison-path'
import RedMetricsPath from '../red-metrics/red-metrics-path'
import GrayMetricsPath from '../gray-metrics/gray-metrics-path'
import MetricFrequencyPath from '../metric-frequency/metric-frequency-path'
import ScorecardStructurePath from '../scorecard-structure/scorecard-structure-path'
import AnnualMetricDataPath from '../annual-metric-data/annual-metric-data-path'
import ScorecardAttributesPath from '../scorecard-attributes/scorecard-attributes-path'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'

const reportTypes = {
	'owner-updater': OwnerUpdaterPath,
	'red-metrics': RedMetricsPath,
	'gray-metrics': GrayMetricsPath,
	'annual-metric-data': AnnualMetricDataPath,
	'scorecard-structure': ScorecardStructurePath,
	'metric-frequency': MetricFrequencyPath,
	'metric-comparison': MetricComparisonPath,
	'scorecard-attributes': ScorecardAttributesPath,
	'scorecard-report-designer': {
		icon: 'settings',
		key: 'report.designer.advancedReport',
		model: ScorecardReportModel
	}
}

const Path = {
	steps: [{
		titleCode: 'report.scorecardReport.chooseReport',
		confirmCode: (_, attrs) => {
			if (attrs.reportType === 'scorecard-report-designer') {
				return 'report.designer.createReport'
			}
		},
		view: ChooseCannedReportStep,
		viewOptions: {
			template,
			reportTypes
		},
		validate: function (attrs, opts) {
			return _.isNil(attrs.reportType)
		}
	}]
}

export default Path

Path.__filename__ = 'reports/wizard/scorecard-report/scorecard-report-path.js'
